module.exports = __webpack_public_path__ + "img/6.be049e3d.png";